import { hasKey } from './utils';
var EventEmitter = require('wolfy87-eventemitter');

class YaganKar {
    constructor() {
        this.bus = new EventEmitter();
    }

    listenToCoreEvents() {
        this.bus.on('validation-error-occured', this.handleValidationError);
    }

    handleValidationError(data) {
        if (hasKey(data, 'errors') && hasKey(data.errors, 'generic_error')) {
            flash.error({ message: data.errors.generic_error[0] });
        }
    }
}

let yagankar = new YaganKar();

yagankar.listenToCoreEvents();

export default yagankar;
